<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>

            <step-container
                :current_step="1"
                :step_list="stepList"
            ></step-container>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0" v-if="init">
                            <BasicInfo
                                class="p-3"
                                :information = information
                                :account_id = account_id
                                :user_no = user_no
                                @on-error = "onError"
                                @file-uploaded = "fileUploaded"
                                ref="basicInfo"
                            ></BasicInfo>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="d-flex">
                        <button @click="nextStep" class="ml-auto btn btn-primary d-block">{{ $t('Next Step') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading || (isLoading === false && init === false)"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import BasicInfo from '@/components/CardManagement/basicInfo';
    import CreateAccount from '@/services/CreateAccount';
    import Account from "@/services/Account";
  
    export default {
        name: 'china-basic-information',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                init : false,
                account_id : '',
                user_no : '',
                information : '',
                stepList:["Basic Information","Legal Information", "Registered Address","Beneficiary Info"]
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            BasicInfo
        },
        methods:{
            nextStep(){
                this.isLoading = true;
                if(this.$refs['basicInfo'].validate()){
                    if(this.user_no){
                        this.$refs['basicInfo'].uploadFile(this.account_id,this.user_no);
                    }
                    else{
                        CreateAccount.createType({"userType":2}).then(response => {
                            const data = response.data.data;
                            this.user_no = data['userNo'];
                            this.account_id = data['accountId'];
                            this.$refs['basicInfo'].uploadFile(data['accountId'],data['userNo']);
                        }).catch(err => {
                            this.checkError(err);
                        });
                    }
                }
                else{
                    this.isLoading = false;
                }
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$swal({
                                    icon: 'info',
                                    html:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                            else{
                                let ret = [];
                                let BasicInfoHongkong = this.$refs['basicInfo'];

                                Object.keys(response.data.message).forEach((key) => {
                                    let error = response.data.message[key][0];
                                    if(typeof BasicInfoHongkong.error[key] !== "undefined"){
                                        BasicInfoHongkong.error[key] = error;
                                    }
                                    
                                    if(key!="accountId"){
                                        ret.push(error);
                                    }
                                });

                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            },
            onError(){
                this.isLoading = false;
            },
            fileUploaded(){
                
                let basic_info = this.$refs['basicInfo'];

                let params = {
                    "accountId":this.account_id,
                    "userNo":""+this.user_no,
                    "license":""+basic_info.file.license,
                    "licenseNo":basic_info.params.licenseNo,
                    "name":basic_info.params.name,
                    "enName":basic_info.params.enName,
                    "endDate":basic_info.params.endDate,
                    "province":basic_info.params.province,
                    "city":basic_info.params.city,
                    "area":basic_info.params.area,
                    "address":basic_info.params.address,
                    "companyType" : basic_info.params.companyType,
                    "managementScope" : basic_info.params.managementScope,
                };

                Account.updateChina(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$router.push({ 
                        name: 'china-legal-information'
                    });
                }).catch(err => {
                    this.checkError(err);
                });
            }
        },
        mounted() {
            this.init = false;
            this.$nextTick(() => {
                CreateAccount.list({start:0, length:-1}).then((response)=>{
                    if (response.status == 200) {
                        if(response.data.data.length>0){
                            this.account_id = response.data.data[0]['id'];
                            this.user_no = response.data.data[0]['userNo'];
                            this.information = response.data.data[0]['information'];
                        }
                        this.init = true;
                    }
                });
            });
        },
    };
  </script>